import React, { useEffect } from "react";

import Main from '../components/Ambassador/Main'

import Footer from "../components/Footer";
import PressRelease from "../components/Ambassador/PressRelease";
import InvestMoney from "../components/Ambassador/InvestMoney";
import QA from "../components/Ambassador/QA";

function Ambassador () {
 
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
    return(
        <div className="relative overflow-hidden mt-[56px]">
            <Main/>
            <PressRelease/>
            <InvestMoney/>
            <QA/>
            <Footer titleKey="ambassador.23" />
        </div>
    );
}

export default Ambassador;